import React from 'react';
import { Modal, Title, Text, Avatar, Badge, Group, Stack, Tabs, Button, Divider } from '@mantine/core';
import { Users, Tag, MessageCircle, Calendar, Edit, Trash } from 'lucide-react';
interface ContactDetailsModalProps {
  opened: boolean;
  onClose: () => void;
  contact: {
    id: number;
    name: string;
    phone: string;
    email?: string;
    lists: string[];
    lastMessage: string;
    totalMessages: number;
    createdAt: string;
    notes?: string;
  };
}
export function ContactDetailsModal({
  opened,
  onClose,
  contact
}: ContactDetailsModalProps) {
  return <Modal opened={opened} onClose={onClose} size="lg" title={<Group data-id="element-27">
          <Avatar size="lg" radius="xl" style={{
      backgroundColor: '#E3F2FD',
      color: '#003d91'
    }} data-id="element-28">
            <Users size={24} data-id="element-29" />
          </Avatar>
          <div data-id="element-30">
            <Title order={3} data-id="element-31">{contact.name}</Title>
            <Text size="sm" c="dimmed" data-id="element-32">
              {contact.phone}
            </Text>
          </div>
        </Group>} data-id="element-26">
      <Tabs defaultValue="info" className="mt-4" data-id="element-33">
        <Tabs.List data-id="element-34">
          <Tabs.Tab value="info" leftSection={<Users size={16} data-id="element-36" />} data-id="element-35">
            Informações
          </Tabs.Tab>
          <Tabs.Tab value="lists" leftSection={<Tag size={16} data-id="element-38" />} data-id="element-37">
            Listas
          </Tabs.Tab>
          <Tabs.Tab value="messages" leftSection={<MessageCircle size={16} data-id="element-40" />} data-id="element-39">
            Mensagens
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="info" pt="md" data-id="element-41">
          <Stack gap="md" data-id="element-42">
            <div data-id="element-43">
              <Text size="sm" fw={500} c="dimmed" data-id="element-44">
                Telefone
              </Text>
              <Text data-id="element-45">{contact.phone}</Text>
            </div>
            {contact.email && <div data-id="element-46">
                <Text size="sm" fw={500} c="dimmed" data-id="element-47">
                  Email
                </Text>
                <Text data-id="element-48">{contact.email}</Text>
              </div>}
            <div data-id="element-49">
              <Text size="sm" fw={500} c="dimmed" data-id="element-50">
                Data de Cadastro
              </Text>
              <Group gap="xs" data-id="element-51">
                <Calendar size={16} data-id="element-52" />
                <Text data-id="element-53">{contact.createdAt}</Text>
              </Group>
            </div>
            <div data-id="element-54">
              <Text size="sm" fw={500} c="dimmed" data-id="element-55">
                Total de Mensagens
              </Text>
              <Text data-id="element-56">{contact.totalMessages} mensagens enviadas</Text>
            </div>
            <div data-id="element-57">
              <Text size="sm" fw={500} c="dimmed" data-id="element-58">
                Última Mensagem
              </Text>
              <Text data-id="element-59">{contact.lastMessage}</Text>
            </div>
            {contact.notes && <div data-id="element-60">
                <Text size="sm" fw={500} c="dimmed" data-id="element-61">
                  Observações
                </Text>
                <Text data-id="element-62">{contact.notes}</Text>
              </div>}
            <Divider data-id="element-63" />
            <Group justify="space-between" data-id="element-64">
              <Button leftSection={<Edit size={16} data-id="element-66" />} variant="light" color="blue" data-id="element-65">
                Editar Contato
              </Button>
              <Button leftSection={<Trash size={16} data-id="element-68" />} variant="light" color="red" data-id="element-67">
                Remover
              </Button>
            </Group>
          </Stack>
        </Tabs.Panel>
        <Tabs.Panel value="lists" pt="md" data-id="element-69">
          <Stack gap="md" data-id="element-70">
            <Text size="sm" c="dimmed" data-id="element-71">
              Este contato pertence às seguintes listas:
            </Text>
            <Group gap="xs" data-id="element-72">
              {contact.lists.map((list, index) => <Badge key={index} size="lg" variant="light" color="blue" data-id="element-73">
                  {list}
                </Badge>)}
            </Group>
            <Button variant="light" color="blue" fullWidth data-id="element-74">
              Adicionar a Nova Lista
            </Button>
          </Stack>
        </Tabs.Panel>
        <Tabs.Panel value="messages" pt="md" data-id="element-75">
          <Stack gap="md" data-id="element-76">
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-77">
              <Group justify="space-between" mb="xs" data-id="element-78">
                <Text size="sm" fw={500} data-id="element-79">
                  Promoção de Maio
                </Text>
                <Text size="xs" c="dimmed" data-id="element-80">
                  Hoje, 09:00
                </Text>
              </Group>
              <Text size="sm" c="dimmed" data-id="element-81">
                Olá! Confira nossas ofertas especiais...
              </Text>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-82">
              <Group justify="space-between" mb="xs" data-id="element-83">
                <Text size="sm" fw={500} data-id="element-84">
                  Lembrete de Reunião
                </Text>
                <Text size="xs" c="dimmed" data-id="element-85">
                  Ontem, 14:30
                </Text>
              </Group>
              <Text size="sm" c="dimmed" data-id="element-86">
                Lembramos que a reunião será amanhã...
              </Text>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-87">
              <Group justify="space-between" mb="xs" data-id="element-88">
                <Text size="sm" fw={500} data-id="element-89">
                  Boas-vindas
                </Text>
                <Text size="xs" c="dimmed" data-id="element-90">
                  22/05/2023, 10:00
                </Text>
              </Group>
              <Text size="sm" c="dimmed" data-id="element-91">
                Bem-vindo ao nosso sistema...
              </Text>
            </div>
          </Stack>
        </Tabs.Panel>
      </Tabs>
    </Modal>;
}